import React from 'react';
import { useDocRectif } from './useDocRectif';
import DocRectifView from './DocRectifView';

export default function DocumentRectificationModal(props) {
  const s = useDocRectif(props);
  return <DocRectifView s={s} />;
}
